<template>
  <div class="blank-content-container mt-5">
    <div class="row pt-4">
      <div class="col">
        <div class="text-center">
          <img
            class="blank-content-icon d-inline img-fluid m-auto"
            :src="require('@/assets/hrVenue/search-big.svg')"
            alt="icon search"
          >
        </div>
      </div>
    </div>
    <div class="row">
      <b-col cols="12">
        <div class="text-center content">
          <h1>{{ resource['pageNotFound.Header'] }}</h1>
          <p class="mb-3">
            {{ resource['pageNotFound.Content'] }}
          </p>
          <!-- <div class="row justify-content-center">
            <router-link v-authenticate="{status:'hide',method:'job.publishnewjob'}"
                         class="btn md with-icon bg-purple text-white mr-5"
                         :to="{name: 'JobCreateView'}"
            >
              {{ resource['view.JobCreate'] }}
            </router-link>
            <router-link class="btn md with-icon bg-purple text-white"
                         :to="{name: 'ActiveJobListView'}"
            >
              {{ resource['view.JobList'] }}
            </router-link>
          </div> -->
        </div>
      </b-col>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoPageNotFound',
  components: {},
};
</script>
<style lang="scss" scoped>
.content {
  h1 {
    color: #353535;
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    margin: 4px 0;
  }

  p {
    color: #858585;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>
